module.exports = "../../documents-flow.JPG";